/* NOVELA — floating buttons + accessibility panel.
   Owns everything the Sense RTL app used to provide, plus our own WhatsApp
   button. State lives in localStorage under nvA11y and is re-applied before
   paint by the inline script in snippets/nv-a11y.liquid. */
(function () {
  'use strict';

  var KEY = 'nvA11y';
  var MODES = ['readable', 'links', 'headings', 'imgdesc', 'kbd', 'stop'];
  var state = { fs: 0, zoom: 0, contrast: '', cursor: '' };

  /* App launchers we replace. Hidden rather than removed, so uninstalling or
     re-installing the app never leaves a hole. */
  var APP_LAUNCHERS = [
    '#carthike-chat-wrapper',
    '#carthike-chat-button-container',
    '#mic-init-access-tool'
  ].join(',');

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (s && typeof s === 'object') {
        state.fs = parseInt(s.fs, 10) || 0;
        state.zoom = parseInt(s.zoom, 10) || 0;
        state.contrast = s.contrast || '';
        state.cursor = s.cursor || '';
        MODES.forEach(function (m) { state[m] = !!s[m]; });
      }
    } catch (e) { /* private mode, blocked storage — carry on with defaults */ }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { }
  }

  function apply() {
    var d = document.documentElement;
    d.style.fontSize = state.fs ? (10 * (1 + state.fs * 0.1)).toFixed(2) + 'px' : '';
    ['nva-zoom-1', 'nva-zoom-2', 'nva-zoom-3'].forEach(function (c) { d.classList.remove(c); });
    if (state.zoom) d.classList.add('nva-zoom-' + state.zoom);
    ['nva-mono', 'nva-soft', 'nva-invert'].forEach(function (c) { d.classList.remove(c); });
    if (state.contrast) d.classList.add('nva-' + state.contrast);
    ['nva-cursor-w', 'nva-cursor-b'].forEach(function (c) { d.classList.remove(c); });
    if (state.cursor) d.classList.add('nva-cursor-' + state.cursor);
    MODES.forEach(function (m) { d.classList.toggle('nva-' + m, !!state[m]); });

    if (state.stop) stopMedia();
    if (state.imgdesc) describeImages();
    sync();
  }

  /* Blocking animations has to reach past CSS: autoplaying video and the
     theme's own sliders keep running otherwise. */
  function stopMedia() {
    document.querySelectorAll('video,audio').forEach(function (v) {
      try { v.pause(); v.removeAttribute('autoplay'); v.autoplay = false; } catch (e) { }
    });
    document.querySelectorAll('[data-autoplay],slideshow-component,slider-component').forEach(function (s) {
      try { if (typeof s.pause === 'function') s.pause(); } catch (e) { }
    });
  }

  function describeImages() {
    document.querySelectorAll('img[alt]').forEach(function (img) {
      var alt = img.getAttribute('alt');
      if (alt && !img.getAttribute('title')) img.setAttribute('title', alt);
    });
  }

  function sync() {
    if (!panel) return;
    panel.querySelectorAll('[data-a11y]').forEach(function (b) {
      var k = b.dataset.a11y, on = false;
      if (k === 'mono' || k === 'soft' || k === 'invert') on = state.contrast === k;
      else if (k === 'cursor-w') on = state.cursor === 'w';
      else if (k === 'cursor-b') on = state.cursor === 'b';
      else if (k === 'zoom') on = state.zoom > 0;
      else if (k === 'fs-up') on = state.fs > 0;
      else if (k === 'fs-down') on = state.fs < 0;
      else on = !!state[k];
      b.setAttribute('aria-pressed', String(on));
    });
  }

  function act(k) {
    if (k === 'fs-up') state.fs = Math.min(5, state.fs + 1);
    else if (k === 'fs-down') state.fs = Math.max(-2, state.fs - 1);
    else if (k === 'zoom') state.zoom = (state.zoom + 1) % 4;
    else if (k === 'mono' || k === 'soft' || k === 'invert') state.contrast = state.contrast === k ? '' : k;
    else if (k === 'cursor-w') state.cursor = state.cursor === 'w' ? '' : 'w';
    else if (k === 'cursor-b') state.cursor = state.cursor === 'b' ? '' : 'b';
    else if (k === 'reset') {
      state = { fs: 0, zoom: 0, contrast: '', cursor: '' };
      MODES.forEach(function (m) { state[m] = false; });
    } else if (MODES.indexOf(k) !== -1) state[k] = !state[k];
    else return;
    save();
    apply();
    layout();
  }

  var panel = null, launcher = null, stack = null, lastFocus = null, openedAt = 0;

  /* ---------- keeping the buttons out of the way ----------
     Anything pinned across the bottom of the viewport — the sticky add-to-cart
     bar above all — would sit underneath the buttons. Measure whatever is down
     there and lift the stack above it instead of guessing a fixed offset. */
  function bottomBarHeight() {
    var vh = window.innerHeight;
    var tallest = 0;
    var nodes = document.body.children;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el === stack || el === panel || !el.getBoundingClientRect) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch (e) { continue; }
      if (cs.position !== 'fixed' || cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') continue;
      var r = el.getBoundingClientRect();
      if (r.height < 30 || r.height > vh * 0.4) continue;      /* not a bar */
      if (r.width < window.innerWidth * 0.6) continue;          /* not full width */
      if (r.bottom < vh - 4 || r.top > vh - 10) continue;       /* not pinned to the bottom */
      if (r.height > tallest) tallest = r.height;
    }
    return Math.round(tallest);
  }

  function layout() {
    if (!stack) return;
    var small = window.innerWidth < 750;
    var base = small ? 12 : 18;
    var bottom = base + bottomBarHeight();
    var d = document.documentElement;
    d.style.setProperty('--nv-float-b', bottom + 'px');
    d.style.setProperty('--nv-panel-b', (bottom + stack.offsetHeight + 10) + 'px');
  }

  /* A drawer or a modal is open: step out of the way entirely. The panel itself
     never counts — it is ours and the button has to stay reachable. */
  function overlayOpen() {
    if (isOpen()) return false;
    var b = document.body;
    if (b.style.overflow === 'hidden' || document.documentElement.style.overflow === 'hidden') return true;
    return !!document.querySelector(
      '.nv-cd.is-open, cart-drawer.active, .menu-drawer-container[open], .drawer.is-open, .modal--open, body.overflow-hidden'
    );
  }

  function hideAppLaunchers() {
    document.querySelectorAll(APP_LAUNCHERS).forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function tick() {
    if (!stack) return;
    layout();
    stack.classList.toggle('is-away', overlayOpen());
  }

  function open() {
    if (!panel) return;
    lastFocus = document.activeElement;
    openedAt = Date.now();
    layout();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    launcher.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('button,a');
    if (first) first.focus();
  }
  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    launcher.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function isOpen() { return !!panel && panel.classList.contains('is-open'); }

  function boot() {
    panel = document.querySelector('[data-nva-panel]');
    stack = document.querySelector('[data-nv-float]');
    launcher = stack && stack.querySelector('[data-nva-launch]');
    if (!panel || !stack || !launcher) return;
    /* A section wrapper would cancel position:fixed — same trap as the drawer. */
    if (stack.parentNode !== document.body) document.body.appendChild(stack);
    if (panel.parentNode !== document.body) document.body.appendChild(panel);

    launcher.addEventListener('click', function () { isOpen() ? close() : open(); });
    panel.addEventListener('click', function (e) {
      var x = e.target.closest('[data-nva-close]');
      if (x) { close(); return; }
      var b = e.target.closest('[data-a11y]');
      if (b) act(b.dataset.a11y);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });
    /* Click-outside closes — but never the very click that opened it. On the
       product page nv-fab.js can proxy this launcher, and that click comes from
       a button outside the panel; it would bubble straight back here and shut
       the panel in the same tick. */
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (Date.now() - openedAt < 400) return;
      if (panel.contains(e.target) || stack.contains(e.target)) return;
      close();
    });

    load();
    apply();

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; tick(); });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', function () { hideAppLaunchers(); schedule(); });

    /* While the bundles and the add-to-cart button are on screen the buttons
       fade back and shrink: that is the one moment where a floating button sits
       on top of something that earns money. Hover or focus brings them back. */
    var buyArea = document.querySelector('.nv-pdp .nv-tiers') || document.querySelector('.nv-pdp [data-nv-atc]');
    if (buyArea && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stack.classList.toggle('is-dim', entries[0].isIntersecting);
      }, { threshold: 0.2 }).observe(buyArea);
    }

    /* The apps mount late and the sticky bar toggles a class as you scroll —
       watch both instead of measuring once. */
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () { hideAppLaunchers(); schedule(); })
        .observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style'] });
    }
    var n = 0;
    (function retry() {
      hideAppLaunchers();
      tick();
      if (++n < 12) setTimeout(retry, 500);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();